import React, { useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophyStar } from '@fortawesome/pro-solid-svg-icons';
import { useEffect } from 'react';
import PropTypes from 'prop-types';

const Totals = ({ studentSessionReport, sessionReportOptions, details, hideRetries, retakeAssignmentToShow, isTeacherReport, reportType }) => {
  const [questionCount, setQuestionCount] = useState();
  const [crQuestionTotal, setCrQuestionTotal] = useState(0);

  useEffect(() => {
    if (studentSessionReport?.studentResult) {
      setQuestionCount(studentSessionReport?.studentResult?.results.length);
    }
    if (studentSessionReport?.studentResults) {
      var questionCount = details?.totals?.correct + details?.totals?.inCorrect + details?.totals?.correctOnRetry;
      var crQuesCount = details?.totals?.crAnswered;
      if(!sessionReportOptions?.scoreUnscoredCRZero) crQuesCount += details?.totals?.crNotAnswered;
      crQuesCount = crQuesCount || studentSessionReport?.studentResults[0]?.results?.filter(q => q.questionType == 'CR').length * studentSessionReport?.studentResults.length;

      setCrQuestionTotal(crQuesCount > 0 ? (details?.totals?.crAnswered / crQuesCount) * 100 : 0);
      setQuestionCount(questionCount || studentSessionReport?.studentResults[0]?.results.length * studentSessionReport?.studentResults.length);
    }
    if(isTeacherReport && (reportType == 'all-admin-assessments' || reportType == 'all-assignments'))
    {
      var crQuestionCount = details?.totals?.crAnswered; 
      if(sessionReportOptions?.scoreNotStarted)
        crQuestionCount += details?.totals?.crNotAnswered;
      setCrQuestionTotal(crQuestionCount > 0 ? (details?.totals?.crAnswered / crQuestionCount) * 100 : 0);
    }
  }, [studentSessionReport, retakeAssignmentToShow, details]);

  const checkIsNaN = (value) =>{
    if(isNaN(value))
      return '0';
    return value;
  };

  const correctOnRetryData = <div className="progress-bar-card">
    <CircularProgressbar
      value={Math.round(
        (details?.totals?.correctOnRetry / questionCount) * 100
      )}
      text={`${questionCount > 0 ? Math.round((details?.totals?.correctOnRetry / questionCount) * 100) : 0}%`}
      strokeWidth={18}
      styles={buildStyles({
        pathColor:
          (details?.totals?.correctOnRetry / questionCount) *
            100 >=
            sessionReportOptions.passingScore
            ? '#52C9A5'
            : '#fb5f5f',
        textColor: '#525252',
        trailColor: '#d6d6d6'
      })}
    />
    <div className="flex-column m-2">
      <p>{details?.totals?.correctOnRetry}</p>
      <span>Correct on Retry</span>
    </div>
  </div>;

  const crAnsweredData = <div className="progress-bar-card">
    <CircularProgressbar
      value={crQuestionTotal}
      text={`${Math.round(
        crQuestionTotal
      )}%`}
      strokeWidth={18}
      styles={buildStyles({
        pathColor:
        crQuestionTotal >=
            sessionReportOptions.passingScore
          ? '#52C9A5'
          : '#fb5f5f',
        textColor: '#525252',
        trailColor: '#d6d6d6'
      })}
    />
    <div className="flex-column m-2">
      <p>{details?.totals?.crAnswered}</p>
      <span>CR Answered</span>
    </div>
  </div>;

  return (
    details?.totals && (
      <div className="row progress_bar_details mt-3">
        <div className="col-lg-3 total-progress-bar">
          {' '}
          <CircularProgressbar
            value={typeof details.totals?.score === 'number' ? details.totals?.score : 0}
            text={`${typeof details.totals?.score === 'number' ? checkIsNaN(Math.round(details.totals?.score)) : 0
            }%`}
            strokeWidth={18}
            styles={buildStyles({
              pathColor:
                details.totals?.score >= sessionReportOptions.passingScore ? '#52C9A5' : '#fb5f5f',
              textColor: '#525252',
              trailColor: '#d6d6d6'
            })}
          />
        </div>
        <div className="col-lg-9 my-auto">
          <div className="row">
            <div className="col-lg-4 d-flex" style={{ '--custom-width': '70px' }}>
              <div className="flex-column w-100">
                <div className="progress-bar-card">
                  <CircularProgressbar
                    value={(details.totals?.correct / questionCount) * 100}
                    text={`${questionCount > 0 ? Math.round((details.totals.correct / questionCount) * 100) : 0}%`}
                    strokeWidth={18}
                    styles={buildStyles({
                      pathColor:
                        (details.totals?.correct / questionCount) * 100 >=
                          sessionReportOptions.passingScore
                          ? '#52C9A5'
                          : '#fb5f5f',
                      textColor: '#525252',
                      trailColor: '#d6d6d6'
                    })}
                  />
                  <div className="flex-column m-2">
                    <p>{details.totals?.correct}</p>
                    <span>Correct</span>
                  </div>
                </div>
                {!hideRetries && correctOnRetryData}
                {hideRetries && crAnsweredData}
              </div>
            </div>
            <div className="col-lg-4 d-flex" style={{ '--custom-width': '70px' }}>
              <div className="flex-column w-100">
                <div className="progress-bar-card">
                  <CircularProgressbar
                    value={(details.totals?.inCorrect / questionCount) * 100}
                    text={`${questionCount > 0 ? Math.round((details.totals?.inCorrect / questionCount) * 100):0}%`}
                    strokeWidth={18}
                    styles={buildStyles({
                      pathColor:
                        (details.totals?.inCorrect / questionCount) * 100 >=
                          sessionReportOptions.passingScore
                          ? '#52C9A5'
                          : '#fb5f5f',
                      textColor: '#525252',
                      trailColor: '#d6d6d6'
                    })}
                  />
                  <div className="flex-column m-2">
                    <p>{details.totals?.inCorrect}</p>
                    <span>Incorrect</span>
                  </div>
                </div>
                {!hideRetries && crAnsweredData}
              </div>
            </div>
            <div className="col-lg-4">
              <div className="total-score-card w-100">
                <FontAwesomeIcon icon={faTrophyStar} size={20} />
                <p>
                  <strong>
                    {typeof details.totals.score === 'number'
                      ? checkIsNaN(Math.round(details.totals?.score))
                      : details.totals.score}
                  </strong>
                </p>
                <h6>Total Score</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

Totals.propTypes = {
  studentSessionReport: PropTypes.array,
  sessionReportOptions: PropTypes.array,
  details: PropTypes.object,
  hideRetries:PropTypes.bool,
  retakeAssignmentToShow:PropTypes.string,
  isTeacherReport:PropTypes.bool,
  reportType:PropTypes.string
};

export default Totals;
